import { render, staticRenderFns } from "./BookingPositionJobandTalentCreate.vue?vue&type=template&id=5e768e0a&"
import script from "./BookingPositionJobandTalentCreate.vue?vue&type=script&lang=js&"
export * from "./BookingPositionJobandTalentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports